module.exports = __webpack_public_path__ + "static/media/29FUNOV7.5501d50f.jpg";